<div class="container py-4">

  <!-- Back Button -->
  <button
    *ngIf="domainService.isCommunityDomain()"
    class="btn btn-outline-primary mb-3 d-flex align-items-center gap-2 btn-lite-blue"
    (click)="goBack()"
  >
    <i class="bi bi-arrow-left"></i> Back
  </button>

  <h2 class="mb-4 section-title titleList">Members</h2>

  <!-- Loading -->
  <div *ngIf="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <!-- Pagination Top (windowed) -->
  <nav *ngIf="!isLoading && totalPages > 1" class="d-flex justify-content-center my-3">
    <ul class="pagination pagination-sm">
      <!-- jump to first -->
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="gotoFirstWindow()">«</a>
      </li>

      <!-- prev 10 -->
      <li class="page-item" [class.disabled]="windowStart <= 1">
        <a class="page-link" (click)="gotoPrevWindow()">
          ‹ <span class="d-none d-sm-inline">10</span>
        </a>
      </li>

      <!-- prev -->
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="onPageChange(currentPage - 1)">‹</a>
      </li>

      <!-- window pages -->
      <li
        class="page-item"
        *ngFor="let p of windowPages"
        [class.active]="currentPage === p"
      >
        <a class="page-link" (click)="onPageChange(p)">{{ p }}</a>
      </li>

      <!-- next -->
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="onPageChange(currentPage + 1)">›</a>
      </li>

      <!-- next 10 -->
      <li class="page-item" [class.disabled]="windowEnd >= totalPages">
        <a class="page-link" (click)="gotoNextWindow()">
          <span class="d-none d-sm-inline">10</span> ›
        </a>
      </li>

      <!-- jump to last -->
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="gotoLastWindow()">»</a>
      </li>
    </ul>
  </nav>

  <!-- Showing X–Y of Z users -->
  <div *ngIf="!isLoading && totalUsers > 0" class="text-end text-muted small mb-2">
    Showing {{ showingFrom }}–{{ showingTo }} of {{ totalUsers }} users
  </div>

  <!-- Table -->
  <div *ngIf="!isLoading && users.length > 0" class="table-responsive">
    <table class="table table-hover align-middle shadow-sm">
      <thead class="custom-thead">
        <tr>
          <th> </th>
          <th>Designation</th>
          <th>Nationality</th>
          <th>Availability</th>
          <th>Last Active</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users; trackBy: trackByUserId">
          <td>
            <div class="d-flex align-items-center gap-2">
              <img
                [src]="user.avatar || 'https://kontact-app-public.s3-ap-southeast-1.amazonaws.com/images/Sign-Up-Image.jpg'"
                class="rounded-circle"
                width="40"
                height="40"
                style="object-fit: cover; cursor: pointer"
                (click)="openProfile(user)"
                [title]="user.name"
              />
              <span class="fw-semibold userName" style="cursor: pointer" (click)="openProfile(user)">
                {{ user.name || '-' }}
              </span>
            </div>
          </td>

          <td>
            <span class="text-dark fw-normal">{{ user.designation || '–' }}</span>
          </td>

          <td>
            <span *ngIf="user.is_public; else hiddenNationality">
              {{ user.nationality || '-' }}
            </span>
            <ng-template #hiddenNationality>
              <span class="text-muted d-flex align-items-center gap-1" title="User has chosen to keep this private">
                <span style="font-size: 1.1rem;">👁️‍🗨️</span> Private
              </span>
            </ng-template>
          </td>

          <!-- Availability -->
          <td>
            <!-- Recruiter badge -->
            <ng-container *ngIf="user.is_recruiter; else seekerAvailability">
              <span
                class="badge availability-badge"
                [ngClass]="(user.recruiter_status || 'PENDING').toUpperCase() === 'APPROVED'
                           ? 'bg-primary text-white'
                           : 'bg-info text-dark'"
                [title]="'Recruiter ' + (user.recruiter_status || 'PENDING')"
              >
                Recruiter
              </span>
            </ng-container>

            <!-- Seeker -->
            <ng-template #seekerAvailability>
              <span *ngIf="user.availability" [ngClass]="getAvailabilityBadgeClass(user.availability)" class="badge">
                {{ getAvailabilityStatus(user.availability) }}
              </span>
              <span *ngIf="!user.availability" class="text-muted">–</span>
            </ng-template>
          </td>

          <td>{{ user.last_active_readable || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- No Users Fallback -->
  <div *ngIf="!isLoading && users.length === 0" class="text-muted text-center my-5">
    No users found.
  </div>

  <!-- Pagination Bottom (windowed) -->
  <nav *ngIf="!isLoading && totalPages > 1" class="d-flex justify-content-center my-3">
    <ul class="pagination pagination-sm">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="gotoFirstWindow()">«</a>
      </li>

      <li class="page-item" [class.disabled]="windowStart <= 1">
        <a class="page-link" (click)="gotoPrevWindow()">
          ‹ <span class="d-none d-sm-inline">10</span>
        </a>
      </li>

      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="onPageChange(currentPage - 1)">‹</a>
      </li>

      <li
        class="page-item"
        *ngFor="let p of windowPages"
        [class.active]="currentPage === p"
      >
        <a class="page-link" (click)="onPageChange(p)">{{ p }}</a>
      </li>

      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="onPageChange(currentPage + 1)">›</a>
      </li>

      <li class="page-item" [class.disabled]="windowEnd >= totalPages">
        <a class="page-link" (click)="gotoNextWindow()">
          <span class="d-none d-sm-inline">10</span> ›
        </a>
      </li>

      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="gotoLastWindow()">»</a>
      </li>
    </ul>
  </nav>

</div>

<!-- Profile Modal -->
<ng-template #profileModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title fw-semibold">
      {{ selectedUser?.is_public ? selectedUser?.name : 'Private User' }}
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="d-flex flex-column align-items-center text-center">
      <img
        [src]="selectedUser?.is_public && selectedUser?.avatar_url ? selectedUser.avatar_url : 'logo/logo.png'"
        class="rounded-circle shadow mb-3"
        style="width: 100px; height: 100px;" />

      <ng-container *ngIf="selectedUser?.is_public; else privateProfile">
        <p *ngIf="selectedUser?.about_me">
          <i class="bi bi-person-lines-fill me-2 text-info"></i>
          <strong>About Me:</strong><br />
          <span class="d-block mt-1">{{ selectedUser.about_me }}</span>
        </p>

        <div *ngIf="selectedUser?.availability" class="mb-3">
          <p class="mb-0">
            <strong>Availability:</strong>
            {{ getAvailabilityStatus(selectedUser.availability) }}
          </p>
        </div>
      </ng-container>

      <ng-template #privateProfile>
        <div class="alert alert-warning w-100 mt-2 text-center">
          This profile is private.
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>
